import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {PhoneModel} from "../phone.model";

export class PhoneConverter extends HttpModelConverter<PhoneModel>{
    protected createInstance(): PhoneModel {
        return new PhoneModel();
    }

    protected enrichObject(result: PhoneModel, src: PhoneModel) {
    }
}